module.exports=function(scope){ return `// Signal to the FaceTec SDK that time based session images should be captured
ZoomSDK.enableTimeBasedSessionImages = true;

// Capture a User Session
zoomSession.capture();

// Sample code to handle the session result
function onZoomSessionComplete(zoomResult) {
    // Handle capture results
    if(!zoomResult.faceMetrics.facemap) {
        appendLog(zoomResult.status);
        // Handle no captured session here
        return;
    }

    if(zoomResult.faceMetrics) {
          // Get the time based session image(s) if available
          if(zoomResult.faceMetrics.timeBasedSessionImages) {
              var timeBasedSessionImages = zoomResult.faceMetrics.timeBasedSessionImages;
              console.log(timeBasedSessionImages.length)
          }
    }
    // Send the data to your chosen API for processing
}`};


// WEBPACK FOOTER //
// ./src/resources/code/web/time-based-images.js.tpl